import { Experiments } from 'constants/optimizely'
import useExperiment from 'hooks/Optimizely/useExperiment'

interface Options {
  isSearchExcluded?: boolean
  exclusionPending?: boolean
}

function usePricePerNightToggleExperiment({
  isSearchExcluded = false,
  exclusionPending = false,
}: Options): boolean {
  const { isAnyVariant: isPricePerNightToggleVariant } = useExperiment(
    Experiments.croPricePerNightToggleOnSearch,
    { canActivate: !exclusionPending && !isSearchExcluded },
  )

  return isPricePerNightToggleVariant && !exclusionPending && !isSearchExcluded
}

export default usePricePerNightToggleExperiment
